import { createContext, useContext, useState, useCallback, useMemo } from 'react'
import type { ReactNode } from 'react'

interface EntityInfo {
  id: string
  name: string
  type: 'association' | 'circle' | 'event'
}

interface EntityContextValue {
  currentEntity: EntityInfo | null
  setCurrentEntity: (entity: EntityInfo | null) => void
}

const EntityContext = createContext<EntityContextValue>({
  currentEntity: null,
  setCurrentEntity: () => {},
})

export function EntityProvider({ children }: { children: ReactNode }) {
  const [currentEntity, setCurrentEntityState] = useState<EntityInfo | null>(null)

  const setCurrentEntity = useCallback((entity: EntityInfo | null) => {
    setCurrentEntityState((prev) => {
      if (prev?.id === entity?.id && prev?.name === entity?.name && prev?.type === entity?.type) return prev
      return entity
    })
  }, [])

  const value = useMemo(() => ({ currentEntity, setCurrentEntity }), [currentEntity, setCurrentEntity])

  return <EntityContext.Provider value={value}>{children}</EntityContext.Provider>
}

export function useCurrentEntity() {
  return useContext(EntityContext)
}
